module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Spitfire.87af6d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Spitfire.jpg
// module id = eM9n
// module chunks = 0